import createBaseService from "@/api/base-service.ts";
import type { WebhookEndpoint } from "../../types/webhook-endpoint";

const webhookEndpointService = {
	...createBaseService<WebhookEndpoint>("/webhook-endpoints"),
};

export default webhookEndpointService;
